// extracted by mini-css-extract-plugin
export default {"container":"OficinasPage_container__u1w5u","containerOne":"OficinasPage_containerOne__GD43a"};